<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import lottie from 'lottie-web'
import { TimelineMax as Line, Power1 } from 'gsap'
import scrollMagic from 'scrollmagic'

export default {

  name: 'RegularSlide',

  props: {
    slides: {
      type: Array,
      default: null
    },
    media: {
      type: String,
      required: true
    },
    mediaLoop: {
      type: Number,
      default: null
    },
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      animation: null,
      itemsScrollOffset: []
    }
  },

  computed: {
    windowWidth () {
      return this.$store.getters['window'].width
    },

    scrollPage (){
      return this.$store.getters['window'].scroll
    },

    isMobile () {
      return this.windowWidth < 768
    },

    isTable (){
      return this.windowWidth <= 1024
    }
  },

  watch: {
    'windowWidth': 'checkState',
    'scrollPage': 'checkState',
  },

  mounted () {
    this.checkState();
    this.checkScrollOffset();
  },

  methods: {

    animatedTrigger (){
      for(let i = 0; i<this.itemsScrollOffset.length; i++){
        let index = this.itemsScrollOffset[i].index;

        if(this.scrollPage > this.itemsScrollOffset[index].offset && !this.itemsScrollOffset[index].animation){
          this.initAnimation(index);
          this.itemsScrollOffset[index].animation = true;
          return;
        }
      }
    },

    checkScrollOffset(){
      for(let i=0; i<this.$refs.item.length; i++ ){
        this.itemsScrollOffset.push(
          {
            offset:this.$refs.item[i].offsetTop,
            index:i,
            animation:false
          }
        )
      }
    },

    checkState () {
      if (this.isMobile && this.animation) {
        this.animation.removeEventListener('complete')
        this.animation.destroy()
        this.animation = null
      }

      if (!this.isMobile && this.animation === null) {
        this.initAnimation()
      }
    },

    initAnimation () {
      if (this.$refs.canvas) {
        this.animation = lottie.loadAnimation({
          container: this.$refs.canvas,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: this.media
        })


        if (this.mediaLoop) {
          this.animation.addEventListener('complete', () => {
            this.animation.goToAndPlay(this.mediaLoop, false)
          })
        }
      }
    },

    destroyAnimation(index){

    },
    enter (el, done) {
      const line = new Line({
        onComplete: done
      })

      line.from(this.$refs.media, 0.5, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      })

      line.from(this.$refs.title, 0.5, {
        autoAlpha: 0,
        y: 40,
        ease: Power1.easeOut,
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, '-=0.1')

      line.from(this.$refs.text, 0.5, {
        autoAlpha: 0,
        x: 40,
        ease: Power1.easeOut,
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, '-=0.25')
    },

    leave (el, done) {
      const line = new Line({
        onComplete: done
      })

      line.to(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut
      })

      const content = [
        this.$refs.title,
        this.$refs.text
      ]

      line.to(content, 0.5, {
        autoAlpha: 0,
        ease: Power1.easeOut
      }, 0.1)
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

section
  article.slide-content(ref="item")
    aside.slide-media(ref="media")
      img.slide-media__image(v-if="isTable", :src="image" alt="image")
      .slide-media__canvas(v-else ref="canvas")
    main.slide-main
      h3.slide-main__title(ref="title") {{ title }}
      p.slide-main__text(ref="text") {{ text }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.whiteBackground

  .slide-main__title,
  .slide-main__text
    color: blue;

.slide-wrap
  position: fixed
  top: 0
  left: 0
  +mobile()
    padding:60px 0

.slide-content
  display flex
  justify-content space-between
  align-items center
  max-width 100%
  width 1280px
  padding 0 80px
  height: 560px

  +hd()
    justify-content flex-start
    width 1600px

  +devices()
    width 440px
    flex-direction column
    padding 0 13px

  +tablet()
    height: auto

  +mobile()
    height: auto
    margin-top: 78px
    width: 100%
    &~&
      margin-top: 60px

.slide-media
  margin-bottom 45px
  width 50%
  padding-right 48px

  +hd()
    margin-right 50px
    max-width 652px

  +devices()
    padding-right 0
    max-width 440px
    width 100%

  +tablet()
    margin-top: 58px
    height: 200px
    text-align: center

    img
      max-height: 100%
      width: auto

  +mobile()
    margin-bottom 30px
    width 50%
    max-width: 148px

  &__image
    width 100%

.slide-main
  width 50%
  display flex
  flex-direction column
  padding-left 65px

  +hd()
    max-width 462px

  +devices()
    padding-left 0
    max-width 100%
    width 440px
  +mobile()
    width: 100%

  &__title
    font-size 36px
    font-weight 300
    line-height 42px

    +mobile()
      font-size 24px
      line-height 29px

    & + *
      margin-top 28px

      +tablet()
        margin-top 21px

      +mobile()
        margin-top 17px

  &__text
    font-size 17px
    line-height 26px

    +devices()
      font-size 14px
      line-height 22px

</style>



// WEBPACK FOOTER //
// regular-slide.vue?6149a186